import { usePreferences } from "@/hooks/useUserPreferences";

export function useMomTypes() {
  const { prefs, loading, refetchPreferences } = usePreferences();
  const momTypes = prefs.mom_types && prefs.mom_types.length > 0 ? prefs.mom_types : null;
  const onboardingComplete = prefs.onboarding_complete;
  return { momTypes, onboardingComplete, loading, refetch: refetchPreferences };
}
